var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83.3159,
    height: 120.392,
    viewBox: "104.174 51.6084 83.3159 120.392",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter02)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.558 81.4164V86.6844C127.558 87.789 126.663 88.6844 125.558 88.6844H107.438C106.334 88.6844 105.438 87.789 105.438 86.6844V76.3604C105.438 70.0404 107.65 64.6684 112.074 60.2444C116.498 55.8204 121.87 53.6084 128.19 53.6084H160.422C166.742 53.6084 172.114 55.8204 176.538 60.2444C180.962 64.6684 183.174 70.0404 183.174 76.3604V96.2684C183.174 101.746 181.225 106.275 177.328 109.856C173.536 113.332 167.901 116.387 160.422 119.02L133.246 128.5C130.613 129.448 128.875 130.291 128.032 131.028C127.295 131.766 126.926 133.03 126.926 134.82V144.512C126.926 145.617 127.822 146.512 128.926 146.512H181.49C182.595 146.512 183.49 147.408 183.49 148.512V166C183.49 167.105 182.595 168 181.49 168H106.174C105.07 168 104.174 167.105 104.174 166V129.764C104.174 124.287 106.07 119.81 109.862 116.334C113.759 112.753 119.447 109.646 126.926 107.012L154.102 97.5324C156.735 96.5844 158.421 95.7417 159.158 95.0044C160.001 94.2671 160.422 93.0031 160.422 91.2124V81.4164C160.422 77.2031 158.315 75.0964 154.102 75.0964H133.878C129.665 75.0964 127.558 77.2031 127.558 81.4164Z",
    fill: "#4E0109"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.558 81.4164V86.6844C127.558 87.789 126.663 88.6844 125.558 88.6844H107.438C106.334 88.6844 105.438 87.789 105.438 86.6844V76.3604C105.438 70.0404 107.65 64.6684 112.074 60.2444C116.498 55.8204 121.87 53.6084 128.19 53.6084H160.422C166.742 53.6084 172.114 55.8204 176.538 60.2444C180.962 64.6684 183.174 70.0404 183.174 76.3604V96.2684C183.174 101.746 181.225 106.275 177.328 109.856C173.536 113.332 167.901 116.387 160.422 119.02L133.246 128.5C130.613 129.448 128.875 130.291 128.032 131.028C127.295 131.766 126.926 133.03 126.926 134.82V144.512C126.926 145.617 127.822 146.512 128.926 146.512H181.49C182.595 146.512 183.49 147.408 183.49 148.512V166C183.49 167.105 182.595 168 181.49 168H106.174C105.07 168 104.174 167.105 104.174 166V129.764C104.174 124.287 106.07 119.81 109.862 116.334C113.759 112.753 119.447 109.646 126.926 107.012L154.102 97.5324C156.735 96.5844 158.421 95.7417 159.158 95.0044C160.001 94.2671 160.422 93.0031 160.422 91.2124V81.4164C160.422 77.2031 158.315 75.0964 154.102 75.0964H133.878C129.665 75.0964 127.558 77.2031 127.558 81.4164Z",
    fill: "url(#paint0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter02",
    x: 104.174,
    y: 51.6084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.968627 0 0 0 0 0.921569 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow",
    result: "effect3_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0",
    x1: 143.832,
    y1: 53.6084,
    x2: 213.341,
    y2: 138.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.398452,
    stopColor: "#C40F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8102E",
    stopOpacity: 0.1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.09bf35fbb6266582667bae2d11455fc2.svg";
export { ForwardRef as ReactComponent };